<template>
	<div class="auth-left">
		<div class="back pointer" @click="goBack">
			<i class="el-icon-arrow-left"></i><span>身份认证</span>
		</div>
		<div class="auth-top">
			<img :src="http + userinfo.avatar" alt="avatar" v-if="userinfo.avatar" />
			<img src="@/assets/avatar.png" alt="avatar" v-else />
			<p>{{userinfo.nickname}}</p>
			<div class="rz1 flex" v-if="stype == 0">
				<img src="@/assets/rz1.png" alt="认证" />
				<span>未认证</span>
			</div>
			<div class="rz2 flex" v-else>
				<img src="@/assets/qy.png" alt="" />
				<span>{{stype==2?'企业':'个人'}}</span>
			</div>
		</div>
		<div class="auth-menu">
			<div class="title pointer" @click="show = !show">
				<span>我的主页</span>
				<i class="el-icon-arrow-up" v-if="show"></i>
				<i class="el-icon-arrow-down" v-else></i>
			</div>
			<div class="list" v-if="show">
				<div class="i pointer" :class="{on:type == 'user'}" @click="pageTo('user')">个人中心</div>
				<div class="i pointer" :class="{on:type == 'credit'}" @click="pageTo('credit')">授信管理</div>
				<div class="i pointer" :class="{on:type == 'myShop'}" @click="pageTo('myShop')">我的店铺</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'hekLeft',
		props: {
			type: {
				type: String,
				default: '/'
			},
			userinfo: {
				type: Object,
				default: {

				}
			},
		},
		data() {
			return {
				show: true,
				status: 0,
				stype: 0,
				http: this.$imgUrl,

			};
		},
		created() {
			this.getUserAuth()
		},
		methods: {
			goBack() {
				this.$router.go(-1);
			},
			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},
			getUserAuth() {
				this.$http.get('/api/user_attestation/index', {

				}).then(res => {
					console.log(res)
					if (res.code == 1 && res.data) {
						this.status = res.data.status
						this.stype = res.data.type

					}
				});
			},

		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.auth-left {
		width: 370px;

		.back {
			span {
				margin-left: 5px;
			}

			&:hover {
				span {
					color: @color2;
				}
			}
		}

		.auth-menu {
			margin-top: 20px;
			border-radius: 10px 10px 10px 10px;
			border: 1px solid #EBEBEB;
			padding-left: 50px;

			.list {
				.i {
					height: 60px;
					line-height: 60px;
					font-size: 16px;
					font-weight: 500;
					color: @color1;
					text-indent: 20px;
					position: relative;

					&:hover {
						color: @color2;


						&::after {
							content: '';
							position: absolute;
							top: 50%;
							left: 0;
							width: 3px;
							height: 14px;
							background: @color2;
							border-radius: 4px;
							margin-top: -7px;
						}
					}
				}

				.on {
					color: @color2;


					&::after {
						content: '';
						position: absolute;
						top: 50%;
						left: 0;
						width: 3px;
						height: 14px;
						background: @color2;
						border-radius: 4px;
						margin-top: -7px;
					}
				}
			}

			.title {
				height: 60px;
				line-height: 60px;
				font-size: 16px;
				font-weight: 500;
				display: flex;
				align-items: center;
				text-align: center;

				span {
					margin-right: 20px;
					text-indent: 20px;
				}
			}
		}

		.auth-top {
			margin-top: 20px;
			width: 100%;
			height: 310px;
			background: linear-gradient(180deg, #FFF5EE 0%, #FFFFFF 50%);
			border-radius: 10px 10px 10px 10px;
			border: 1px solid #EBEBEB;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			flex-direction: column;

			img {
				width: 120px;
				height: 120px;
				background: #FFFFFF;
				border-radius: 100px 100px 100px 100px;
				border: 1px solid #EBEBEB;
				overflow: hidden;
			}

			p {

				height: 40px;
				line-height: 40px;
				font-weight: bold;
				font-size: 28px;
				color: #11192D;
				text-align: center;
				margin-top: 15px;
			}

			.rz2 {

				width: 60px;
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				background: #FFF5EE;
				border-radius: 4px 4px 4px 4px;
				line-height: 24px;
				height: 24px;
				margin-top: 15px;

				img {
					width: 20px;
					height: 20px;
				}

				span {
					margin-left: 5px;
					font-size: 14px;
					color: @color2;

				}
			}

			.rz1 {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				width: 74px;
				background: #F5F5F5;
				border-radius: 4px 4px 4px 4px;
				line-height: 24px;
				height: 24px;
				margin-top: 15px;

				img {
					width: 20px;
					height: 20px;
				}

				span {
					margin-left: 5px;
					font-size: 14px;
					color: #BFBFBF;

				}
			}
		}
	}
</style>